// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3nq7c","validationTips":"StatementDescriptor_validationTips__19fX0"};